import styled from 'styled-components';

export const Styled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  span {
    color: #6c7279;
  }
`;
